import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { message } from 'antd';
import copyToClipboard from 'copy-to-clipboard';
import { Copy } from 'lucide-react';

type Props = { className?: string; copyText: string } & PropsWithChildren;

const CopyButton = ({ className, children, copyText }: Props) => {
  return (
    <div className={classNames(className, 'flex items-center gap-1')}>
      {children}
      <button
        className="p-1 bg-transparent hover:text-blue-500 flex items-center justify-center"
        onClick={() => {
          copyToClipboard(copyText);
          message.success(i18n.t(LOCALS.kTFIViDbSC));
        }}
      >
        <Copy className="w-5 h-5" />
      </button>
    </div>
  );
};

export default CopyButton;
